import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import productService from '../services/productService';
import ProductForm from '../components/ProductForm';

const EditProductPage = () => {
  const { productId } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const loadProduct = async () => {
      setLoading(true);
      setError('');

      try {
        const result = await productService.getProductById(productId);

        if (!cancelled) setProduct(result);
      } catch (err) {
        if (!cancelled) {
          setError(
            err.response?.data?.message ||
              'Unable to load this product.'
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadProduct();

    return () => {
      cancelled = true;
    };
  }, [productId]);

  const handleUpdate = async (productData) => {
    setSaving(true);
    setError('');

    try {
      await productService.updateProduct(productId, productData);

      navigate('/user/products', {
        replace: true,
        state: { notice: 'Product updated successfully.' },
      });
    } catch (err) {
      const validationErrors = err.response?.data?.errors || [];
      const validationMessage = validationErrors
        .map((item) => item.message)
        .join(' ');

      setError(
        validationMessage ||
          err.response?.data?.message ||
          'Unable to update product.'
      );
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <p className="product-table-message">Loading product...</p>;
  }

  return (
    <section className="products-page">
      <div className="products-page-header">
        <div>
          <h1>Edit Product</h1>
          <p>Update the product details.</p>
        </div>

        <Link
          to="/user/products"
          className="product-secondary-button"
        >
          Back to Products
        </Link>
      </div>

      {error && (
        <div className="product-alert product-alert-error">
          {error}
        </div>
      )}

      {product ? (
        <div className="product-form-card">
          <ProductForm
            key={product.id}
            initialValues={product}
            onSubmit={handleUpdate}
            submitLabel="Save Changes"
            loading={saving}
          />
        </div>
      ) : (
        !error && <p>Product not found.</p>
      )}
    </section>
  );
};

export default EditProductPage;